import './accounts.commands'
import BookkeepingAccountsView from '@/bookkeeping-account/BookkeepingAccountsView.vue'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerRoute} from '@/router'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'

export const BOOKKEEPING_ACCOUNT = {componentName: 'Accounts', component: BookkeepingAccountsView, meta: {requiresOrg: true}}
const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()


const icon = 'i-ph-list-fill'
const label = 'Kontoplan'
const route = BOOKKEEPING_ACCOUNT

registerNavigationCommand({
    route,
    label,
    icon
})
registerNavigationEntry(NavGroup.MISC, {
    title: label,
    key: 'bookkeeping-account',
    icon,
    target: route,
    sortOrder: 3
})

registerRoute(route)
buildSimpleCrumb(route, label, icon)